// extracted by mini-css-extract-plugin
module.exports = {"controls":"recipient-form_controls__Gadxa","section":"recipient-form_section__2bZPF"};